import { useState } from 'preact/hooks';

import { ROUTE_VIEW_MAP } from '@/helpers/constants/routes';
import type { T_NavigationBase } from '@/types/Navigation';
import { E_AppRoutes } from '@/types/Routes';
import type { E_ActiveView } from '@/types/WidgetHeader';

export const useNavigationBase = ({ isRegistered, phoneNumber }: T_NavigationBase) => {
  let defaultRoute = E_AppRoutes.REGISTERED_CUSTOMER;

  if (!isRegistered) {
    defaultRoute = E_AppRoutes.LOGIN;
  } else if (!phoneNumber) {
    defaultRoute = E_AppRoutes.UNREGISTERED_CUSTOMER;
  }

  const [activeRoute, setActiveRoute] = useState<E_AppRoutes>(defaultRoute);
  const [activeView, setActiveView] = useState<E_ActiveView>(ROUTE_VIEW_MAP[defaultRoute]);

  const navigateTo = (newRoute: E_AppRoutes) => {
    if (newRoute !== activeRoute) {
      setActiveRoute(newRoute);
      setActiveView(ROUTE_VIEW_MAP[newRoute]);
    }
  };

  return { activeRoute, activeView, navigateTo };
};
